// extracted by mini-css-extract-plugin
export default {"input-file-section":"InputFile_input-file-section__yIxdS"};